import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{body-class "user-activity-page"}}

<div class="user-navigation user-navigation-secondary">
  <HorizontalOverflowNav @ariaLabel="User secondary - activity">
    <DNavigationItem
      @route="userActivity.index"
      @ariaCurrentContext="subNav"
      class="user-nav__activity-all"
    >
      {{d-icon "stream"}}
      <span>{{i18n "user.filters.all"}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="userActivity.topics"
      @ariaCurrentContext="subNav"
      class="user-nav__activity-topics"
    >
      {{d-icon "list-ul"}}
      <span>{{i18n "user_action_groups.4"}}</span>
    </DNavigationItem>
    <DNavigationItem
      @route="userActivity.replies"
      @ariaCurrentContext="subNav"
      class="user-nav__activity-replies"
    >
      {{d-icon "reply"}}
      <span>{{i18n "user_action_groups.5"}}</span>
    </DNavigationItem>

    {{#if this.user.showRead}}
      <DNavigationItem
        @route="userActivity.read"
        @ariaCurrentContext="subNav"
        class="user-nav__activity-read"
        title={{i18n "user.read_help"}}
      >
        {{d-icon "history"}}
        <span>{{i18n "user.read"}}</span>
      </DNavigationItem>
    {{/if}}

    {{#if this.user.showDrafts}}
      <DNavigationItem
        @route="userActivity.drafts"
        @ariaCurrentContext="subNav"
        class="user-nav__activity-drafts"
      >
        {{d-icon "pencil-alt"}}
        <span>{{this.draftLabel}}</span>
      </DNavigationItem>
    {{/if}}

    {{#if (gt this.model.pending_posts_count 0)}}
      <DNavigationItem
        @route="userActivity.pending"
        @ariaCurrentContext="subNav"
        class="user-nav__activity-pending"
      >
        {{d-icon "clock"}}
        <span>{{this.pendingLabel}}</span>
      </DNavigationItem>
    {{/if}}

    <DNavigationItem
      @route="userActivity.likesGiven"
      @ariaCurrentContext="subNav"
      class="user-nav__activity-likes"
    >
      {{d-icon "heart"}}
      <span>{{i18n "user_action_groups.1"}}</span>
    </DNavigationItem>

    {{#if this.user.showBookmarks}}
      <DNavigationItem
        @route="userActivity.bookmarks"
        @ariaCurrentContext="subNav"
        class="user-nav__activity-bookmarks"
      >
        {{d-icon "bookmark"}}
        <span>{{i18n "user_action_groups.3"}}</span>
      </DNavigationItem>
    {{/if}}

    <PluginOutlet
      @name="user-activity-bottom"
      @connectorTagName="li"
      @outletArgs={{hash model=this.model}}
    />
  </HorizontalOverflowNav>
</div>

<section class="user-content" id="user-content">
  {{outlet}}
</section>
*/
{
  "id": "DFGTrbq+",
  "block": "[[[1,[28,[35,0],[\"user-activity-page\"],null]],[1,\"\\n\\n\"],[10,0],[14,0,\"user-navigation user-navigation-secondary\"],[12],[1,\"\\n  \"],[8,[39,1],null,[[\"@ariaLabel\"],[\"User secondary - activity\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,2],[[24,0,\"user-nav__activity-all\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userActivity.index\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"stream\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user.filters.all\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,2],[[24,0,\"user-nav__activity-topics\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userActivity.topics\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"list-ul\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user_action_groups.4\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[39,2],[[24,0,\"user-nav__activity-replies\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userActivity.replies\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"reply\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user_action_groups.5\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"user\",\"showRead\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"user-nav__activity-read\"],[16,\"title\",[28,[37,4],[\"user.read_help\"],null]]],[[\"@route\",\"@ariaCurrentContext\"],[\"userActivity.read\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"history\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,4],[\"user.read\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"user\",\"showDrafts\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"user-nav__activity-drafts\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userActivity.drafts\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"pencil-alt\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[30,0,[\"draftLabel\"]]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,6],[[30,0,[\"model\",\"pending_posts_count\"]],0],null],[[[1,\"      \"],[8,[39,2],[[24,0,\"user-nav__activity-pending\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userActivity.pending\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"clock\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[30,0,[\"pendingLabel\"]]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,2],[[24,0,\"user-nav__activity-likes\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userActivity.likesGiven\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"heart\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"user_action_groups.1\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"user\",\"showBookmarks\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"user-nav__activity-bookmarks\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userActivity.bookmarks\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"bookmark\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,4],[\"user_action_groups.3\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,7],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-activity-bottom\",\"li\",[28,[37,8],null,[[\"model\"],[[30,0,[\"model\"]]]]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"section\"],[14,0,\"user-content\"],[14,1,\"user-content\"],[12],[1,\"\\n  \"],[46,[28,[37,10],null,null],null,null,null],[1,\"\\n\"],[13]],[],false,[\"body-class\",\"horizontal-overflow-nav\",\"d-navigation-item\",\"d-icon\",\"i18n\",\"if\",\"gt\",\"plugin-outlet\",\"hash\",\"component\",\"-outlet\"]]",
  "moduleName": "discourse/templates/user/activity.hbs",
  "isStrictMode": false
});